import { createContext } from "react";

export interface FeatureFlagsContextType {
  flags: Record<string, boolean>;
}

export const FeatureFlagsContext = createContext<FeatureFlagsContextType>({
  flags: {},
});
